import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { DynamicSvg } from '@airtel/air-design-system';
import { TypographyWidget } from '../../../typography-widget';
import { getValidationRuleStyles } from './ValidationRuleStyles';
var ValidationRule = _ref => {
  var rule = _ref.rule,
    index = _ref.index,
    iconSize = _ref.iconSize;
  var ruleText = rule.ruleText,
    successIcon = rule.successIcon,
    failureIcon = rule.failureIcon,
    isValid = rule.isValid,
    style = rule.style;
  var validationRuleStyles = getValidationRuleStyles();
  return _jsxs(View, Object.assign({
    style: [validationRuleStyles.ruleContainer, style]
  }, {
    children: [_jsx(DynamicSvg, {
      iconName: isValid ? successIcon === null || successIcon === void 0 ? void 0 : successIcon.iconName : failureIcon === null || failureIcon === void 0 ? void 0 : failureIcon.iconName,
      color: isValid ? successIcon === null || successIcon === void 0 ? void 0 : successIcon.color : failureIcon === null || failureIcon === void 0 ? void 0 : failureIcon.color,
      fontSize: iconSize,
      style: [validationRuleStyles === null || validationRuleStyles === void 0 ? void 0 : validationRuleStyles.iconStyle, isValid ? successIcon === null || successIcon === void 0 ? void 0 : successIcon.style : failureIcon === null || failureIcon === void 0 ? void 0 : failureIcon.style]
    }), _jsx(TypographyWidget, Object.assign({
      text: ruleText
    }, isValid ? rule.successTextProps : rule.failureTextProps))]
  }), "rule_item_" + index);
};
export default ValidationRule;